import { render, staticRenderFns } from "./ChangeClass.vue?vue&type=template&id=df35db66"
import script from "./ChangeClass.vue?vue&type=script&lang=js"
export * from "./ChangeClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports